import { logError } from 'lib/sentry/logError';
import { MenuItem } from 'shared';
import { updateArrayById } from 'shared_DEPRECATED/utils';

import { ChallengeTimelineItemType } from 'features/challenge/ChallengeTimelineItem';
import { useAddCustomChallenge } from 'features/challenge/hooks/useAddCustomChallenge';
import {
  usePlanningDraftSprintsQueryActions,
  IPlanningDraftSprint,
  usePlanningAnalyticsEvents,
} from 'features/planning';

import { showErrorToast } from 'shared/components/Toast';

type TPlanningDraftSprintAddChallengeButton = {
  sprint: IPlanningDraftSprint;
};

export const PlanningDraftSprintAddChallengeButton = ({
  sprint,
}: TPlanningDraftSprintAddChallengeButton) => {
  const { sendPlanningChallengeAddedEvent } = usePlanningAnalyticsEvents();
  const { getDraftSprints, updateDraftSprints, cancelDraftSprintsQueries } =
    usePlanningDraftSprintsQueryActions();

  const openAddChallengeModal =
    useAddCustomChallenge<ChallengeTimelineItemType>({
      //@ts-ignore
      sprint,
      options: {
        //@ts-ignore
        onMutate: async ({
          challenges: challenge,
        }: {
          challenges: ChallengeTimelineItemType[];
        }) => {
          await cancelDraftSprintsQueries();
          const previousDraftSprintsValue = getDraftSprints();

          const updatedItems = updateArrayById({
            array: previousDraftSprintsValue!.sprints,
            updatedItem: {
              ...sprint,
              challenges: [...sprint.challenges, challenge],
            },
            idProperty: 'sprintId',
          });

          updateDraftSprints(updatedItems);

          return { challenges: previousDraftSprintsValue?.sprints ?? [] };
        },
        onSuccess: async (response) => {
          const previousDraftSprintsValue = getDraftSprints();

          const updatedItems = updateArrayById({
            array: previousDraftSprintsValue!.sprints,
            updatedItem: {
              ...sprint,
              // @ts-ignore
              challenges: [...sprint.challenges, ...response.challenges],
            },
            idProperty: 'sprintId',
          });

          updateDraftSprints(updatedItems);

          sendPlanningChallengeAddedEvent('sprintDraft');
        },
        onError: (err: Error, __: any, context) => {
          if (!context?.challenges) {
            return;
          }
          //@ts-ignore
          updateDraftSprints(context.challenges);
          logError(err);
          showErrorToast('Failed to add challenge to sprint');
        },
      },
      parameters: { addToSprintId: sprint.sprintId },
    });

  return (
    <MenuItem
      onClick={openAddChallengeModal}
      data-testid="add-challenge-draft-sprint-option"
    >
      Add challenge
    </MenuItem>
  );
};
